import { useState, useEffect } from "react";
import {
  Building2,
  Search,
  Plus,
  Edit,
  Ban,
  Power,
  X,
  Save,
  Loader2,
  RefreshCw,
  Mail,
  Phone,
  MapPin,
  FileText,
  ArrowUpDown,
  Network,
  Calendar,
  ToggleLeft,
  ToggleRight,
  Package,
  UserPlus,
  Truck,
  // Shield, // ✅ NUEVO
  // ChevronDown, // ✅ NUEVO
  // ChevronRight, // ✅ NUEVO
} from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Checkbox } from "./ui/checkbox";
import Swal from "sweetalert2";
// Al inicio, junto a los otros imports
import ModulosEmpresa from "./ModulosEmpresa";
const Empresas = () => {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingEmpresa, setEditingEmpresa] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: "nombre",
    direction: "asc",
  });
  const [filters, setFilters] = useState({
    buscar: "",
    activo: "",
    tipo_empresa: "",
  });
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    total: 0,
  });
  const [formData, setFormData] = useState({
    nombre: "",
    ruc: "",
    email: "",
    telefono: "",
    direccion: "",
    tipo_empresa: "CLIENTE",
    activo: true,
    admin_password: "",
    // plantilla_empresa_id: "", // ✅ NUEVO
  });

  const [showRelacionesModal, setShowRelacionesModal] = useState(false);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
  const [relacionesEmpresa, setRelacionesEmpresa] = useState([]);
  const [loadingRelaciones, setLoadingRelaciones] = useState(false);
  const [showNuevaRelacionModal, setShowNuevaRelacionModal] = useState(false);
  const [loadingEmpresas, setLoadingEmpresas] = useState(false);
  // Dentro del componente, junto a los otros useState
  const [showModulosModal, setShowModulosModal] = useState(false);
   const [logoFile, setLogoFile]           = useState(null);
  const [logoPreview, setLogoPreview]     = useState(null);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [empresaParaModulos, setEmpresaParaModulos] = useState(null);
  const [empresasParaRelacion, setEmpresasParaRelacion] = useState({
    almaceneras: [],
    navieras: [],
  });
  const [formDataRelacion, setFormDataRelacion] = useState({
    empresaid_almacenera: "",
    empresaid_naviera: "",
    fecha_inicio: "",
    fecha_fin: "",
    estado: "ACTIVO",
  });

  const [showRelacionesOperadorModal, setShowRelacionesOperadorModal] =
    useState(false);
  const [relacionesOperador, setRelacionesOperador] = useState([]);
  const [loadingRelacionesOperador, setLoadingRelacionesOperador] =
    useState(false);
  const [estadisticasOperador, setEstadisticasOperador] = useState({});
  const [showNuevaRelacionOperadorModal, setShowNuevaRelacionOperadorModal] =
    useState(false);
  const [loadingEmpresasOperador, setLoadingEmpresasOperador] = useState(false);
  const [empresasDisponibles, setEmpresasDisponibles] = useState({
    clientes_disponibles: [],
    transportistas_disponibles: [],
  });
  const [nuevaRelacion, setNuevaRelacion] = useState({
    tipo_relacion: "cliente",
    empresa_id: "",
    fecha_inicio: new Date().toISOString().split("T")[0],
    fecha_fin: "",
    estado: "ACTIVO",
  });
  // Estados para configuración de menús
  // const [showConfigMenusModal, setShowConfigMenusModal] = useState(false);
  // const [empresaConfigMenus, setEmpresaConfigMenus] = useState(null);
  // const [todosLosMenus, setTodosLosMenus] = useState([]);
  // const [menusSeleccionados, setMenusSeleccionados] = useState([]);
  // const [loadingMenus, setLoadingMenus] = useState(false);
  // const [expandedMenus, setExpandedMenus] = useState(new Set());
  const [showInvitarAdminModal, setShowInvitarAdminModal] = useState(false);
  const [empresaParaInvitar, setEmpresaParaInvitar] = useState(null);
  const [formInvitacion, setFormInvitacion] = useState({
    admin_nombre: "",
    admin_email: "",
  });
  const abrirModalInvitarAdmin = (empresa) => {
    setEmpresaParaInvitar(empresa);
    setFormInvitacion({ admin_nombre: "", admin_email: "" });
    setShowInvitarAdminModal(true);
  };
  const abrirModalModulos = (empresa) => {
    setEmpresaParaModulos(empresa);
    setShowModulosModal(true);
  };
  const enviarInvitacionAdmin = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const response = await fetch(
        `${getApiUrl()}/empresas/${empresaParaInvitar.id}/invite-admin`,
        {
          method: "POST",
          headers: getHeaders(),
          body: JSON.stringify(formInvitacion),
        },
      );

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "✓ Invitación enviada",
          text: `Se envió una invitación a ${formInvitacion.admin_email}`,
          timer: 3000,
        });
        setShowInvitarAdminModal(false);
      } else {
        throw new Error(result.message || "Error al enviar invitación");
      }
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setSaving(false);
    }
  };
  // Estados para plantillas
  // const [plantillasDisponibles, setPlantillasDisponibles] = useState([]);
  // const [loadingPlantillas, setLoadingPlantillas] = useState(false);
  const tiposEmpresa = [
    {
      value: "OPERADOR_LOGISTICO",
      label: "Operador Logístico",
      color: "bg-blue-100 text-blue-700",
    },
    {
      value: "CLIENTE",
      label: "Cliente",
      color: "bg-green-100 text-green-700",
    },
    {
      value: "TRANSPORTISTA",
      label: "Transportista",
      color: "bg-purple-100 text-purple-700",
    },
    {
      value: "ALMACENERA",
      label: "Almacenera",
      color: "bg-orange-100 text-orange-700",
    },
    { value: "NAVIERA", label: "Naviera", color: "bg-cyan-100 text-cyan-700" },
  ];
  // const cargarPlantillasDisponibles = async () => {
  //   setLoadingPlantillas(true);
  //   try {
  //     const response = await fetch(`${getApiUrl()}/empresas/plantillas`, {
  //       headers: getHeaders(),
  //     });

  //     if (response.ok) {
  //       const data = await response.json();
  //       setPlantillasDisponibles(data.data || []);
  //     }
  //   } catch (error) {
  //     console.error("Error cargando plantillas:", error);
  //   } finally {
  //     setLoadingPlantillas(false);
  //   }
  // };

  // const toggleMenuExpansion = (menuId) => {
  //   const newExpanded = new Set(expandedMenus);
  //   if (newExpanded.has(menuId)) {
  //     newExpanded.delete(menuId);
  //   } else {
  //     newExpanded.add(menuId);
  //   }
  //   setExpandedMenus(newExpanded);
  // };

  // useEffect(() => {
  //   if (showModal && !editingEmpresa) {
  //     cargarPlantillasDisponibles();
  //   }
  // }, [showModal, editingEmpresa]);

  useEffect(() => {
    loadEmpresas();
  }, [
    filters.buscar,
    filters.activo,
    filters.tipo_empresa,
    pagination.current_page,
  ]);

  const getApiUrl = () => {
    return process.env.REACT_APP_API_URL || "http://localhost:8000/api";
  };

  const getHeaders = () => {
    const token = localStorage.getItem("token");
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  };

  const loadEmpresas = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: pagination.current_page,
        perPage: 15,
      });

      if (filters.buscar) params.append("buscar", filters.buscar);
      if (filters.activo) params.append("activo", filters.activo);
      if (filters.tipo_empresa)
        params.append("tipo_empresa", filters.tipo_empresa);

      const response = await fetch(`${getApiUrl()}/empresas?${params}`, {
        method: "GET",
        headers: getHeaders(),
      });

      if (response.ok) {
        const data = await response.json();
        setEmpresas(data.data);
        setPagination(data.pagination);
      } else {
        throw new Error("Error al cargar empresas");
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Error al cargar datos",
        showConfirmButton: false,
        timer: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedEmpresas = [...empresas].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  
  const handleSubmit = async (e) => {
      e.preventDefault();
      setSaving(true);

      try {
          const url    = editingEmpresa
              ? `${getApiUrl()}/empresas/${editingEmpresa.id}`
              : `${getApiUrl()}/empresas`;
          const method = editingEmpresa ? 'PUT' : 'POST';

          const response = await fetch(url, {
              method,
              headers: getHeaders(),
              body: JSON.stringify(formData),
          });

          const result = await response.json();
          if (!response.ok) throw new Error(result.message || 'Error al guardar');

          // Subir logo si hay archivo nuevo
          const empresaId = editingEmpresa?.id || result.data?.id;
          if (logoFile && empresaId) {
              setUploadingLogo(true);
              const formLogo = new FormData();
              formLogo.append('logo', logoFile);
              const token = localStorage.getItem('token');
              await fetch(`${getApiUrl()}/empresas/${empresaId}/logo`, {
                  method: 'POST',
                  headers: {
                      Accept: 'application/json',
                      ...(token && { Authorization: `Bearer ${token}` }),
                      // NO poner Content-Type — el browser lo gestiona con FormData
                  },
                  body: formLogo,
              });
              setUploadingLogo(false);
          }

          Swal.fire({
              toast: true, position: 'top-end', icon: 'success',
              title: result.message, showConfirmButton: false, timer: 2000,
          });
          closeModal();
          loadEmpresas();

      } catch (error) {
          Swal.fire('Error', error.message, 'error');
      } finally {
          setSaving(false);
          setUploadingLogo(false);
      }
  };



  const handleEdit = (empresa) => {
      setEditingEmpresa(empresa);
      setFormData({
          nombre:       empresa.nombre,
          ruc:          empresa.ruc,
          email:        empresa.email || '',
          telefono:     empresa.telefono || '',
          direccion:    empresa.direccion || '',
          tipo_empresa: empresa.tipo_empresa,
          activo:       empresa.activo,
      });
      setLogoFile(null);
      setLogoPreview(empresa.logo_url || null);
      setShowModal(true);
  };

  const handleDelete = async (empresa) => {
    const result = await Swal.fire({
      title: "⚠️ Desactivar Empresa",
      html: `<p>¿Estás seguro de desactivar la empresa:</p><p class="font-bold text-lg mt-2">${empresa.nombre}</p>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f59e0b",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "✓ Sí, desactivar",
      cancelButtonText: "✕ Cancelar",
      customClass: {
        popup: "rounded-lg",
        confirmButton: "rounded-md",
        cancelButton: "rounded-md",
      },
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(`${getApiUrl()}/empresas/${empresa.id}`, {
          method: "DELETE",
          headers: getHeaders(),
        });

        if (response.ok) {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "✓ Empresa desactivada",
            showConfirmButton: false,
            timer: 2000,
          });
          loadEmpresas();
        }
      } catch (error) {
        console.error("Error:", error);
        Swal.fire("Error", "No se pudo desactivar la empresa", "error");
      }
    }
  };

  const toggleActivo = async (empresa) => {
    try {
      const response = await fetch(
        `${getApiUrl()}/empresas/${empresa.id}/toggle-activo`,
        {
          method: "PATCH",
          headers: getHeaders(),
        },
      );

      if (response.ok) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Estado actualizado",
          showConfirmButton: false,
          timer: 1500,
        });
        loadEmpresas();
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", "No se pudo cambiar el estado", "error");
    }
  };

   const openModal = () => {
      setEditingEmpresa(null);
      setFormData({
          nombre: '', ruc: '', email: '',
          telefono: '', direccion: '',
          tipo_empresa: 'CLIENTE', activo: true,
      });
      setLogoFile(null);
      setLogoPreview(null);
      setShowModal(true);
  };
 const handleLogoChange = (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const allowed = ['image/svg+xml', 'image/png', 'image/webp', 'image/jpeg'];
      if (!allowed.includes(file.type)) {
          Swal.fire('Formato inválido', 'Use SVG, PNG, WEBP o JPG/JPEG.', 'warning');
          return;
      }
      if (file.size > 2 * 1024 * 1024) {
          Swal.fire('Archivo muy grande', 'El logo no debe superar los 2 MB.', 'warning');
          return;
      }
      setLogoFile(file);
      setLogoPreview(URL.createObjectURL(file));
  };
  const closeModal = () => {
    setShowModal(false);
    setEditingEmpresa(null);
  };

  const getTipoEmpresa = (tipo) => {
    return (
      tiposEmpresa.find((t) => t.value === tipo) || {
        label: tipo,
        color: "bg-gray-100 text-gray-700",
      }
    );
  };

  const abrirModalRelaciones = async (empresa) => {
    setEmpresaSeleccionada(empresa);
    setShowRelacionesModal(true);
    await cargarRelacionesEmpresa(empresa);
  };

  const cargarRelacionesEmpresa = async (empresa) => {
    setLoadingRelaciones(true);
    try {
      const endpoint =
        empresa.tipo_empresa === "ALMACENERA"
          ? `almaceneras-navieras/por-almacenera/${empresa.id}`
          : `almaceneras-navieras/por-naviera/${empresa.id}`;

      const response = await fetch(`${getApiUrl()}/${endpoint}`, {
        headers: getHeaders(),
      });

      if (response.ok) {
        const data = await response.json();
        setRelacionesEmpresa(data.data || []);
      } else {
        throw new Error("Error al cargar relaciones");
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Error al cargar relaciones",
        showConfirmButton: false,
        timer: 3000,
      });
      setRelacionesEmpresa([]);
    } finally {
      setLoadingRelaciones(false);
    }
  };

  const abrirModalNuevaRelacion = async () => {
    const today = new Date().toISOString().split("T")[0];

    if (empresaSeleccionada.tipo_empresa === "ALMACENERA") {
      setFormDataRelacion({
        empresaid_almacenera: empresaSeleccionada.id,
        empresaid_naviera: "",
        fecha_inicio: today,
        fecha_fin: "",
        estado: "ACTIVO",
      });
    } else {
      setFormDataRelacion({
        empresaid_almacenera: "",
        empresaid_naviera: empresaSeleccionada.id,
        fecha_inicio: today,
        fecha_fin: "",
        estado: "ACTIVO",
      });
    }

    setShowNuevaRelacionModal(true);
    await cargarEmpresasParaRelacion();
  };

  const cargarEmpresasParaRelacion = async () => {
    setLoadingEmpresas(true);

    try {
      const response = await fetch(
        `${getApiUrl()}/almaceneras-navieras/empresas/disponibles`,
        {
          headers: getHeaders(),
        },
      );

      if (response.ok) {
        const data = await response.json();
        setEmpresasParaRelacion(data.data || { almaceneras: [], navieras: [] });
      } else {
        throw new Error("Error al cargar empresas");
      }
    } catch (error) {
      console.error("Error cargando empresas:", error);
      setEmpresasParaRelacion({ almaceneras: [], navieras: [] });

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Error al cargar empresas",
        showConfirmButton: false,
        timer: 2000,
      });
    } finally {
      setLoadingEmpresas(false);
    }
  };

  const getEmpresasDisponiblesParaRelacion = () => {
    if (!empresaSeleccionada) return [];

    const empresasTarget =
      empresaSeleccionada.tipo_empresa === "ALMACENERA"
        ? empresasParaRelacion.navieras
        : empresasParaRelacion.almaceneras;

    return empresasTarget.map((empresa) => {
      const tieneRelacionActiva = relacionesEmpresa.some((relacion) => {
        if (empresaSeleccionada.tipo_empresa === "ALMACENERA") {
          return (
            relacion.empresaid_naviera === empresa.id &&
            relacion.estado === "ACTIVO"
          );
        } else {
          return (
            relacion.empresaid_almacenera === empresa.id &&
            relacion.estado === "ACTIVO"
          );
        }
      });

      return {
        ...empresa,
        tieneRelacion: tieneRelacionActiva,
      };
    });
  };

  const crearNuevaRelacion = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const response = await fetch(`${getApiUrl()}/almaceneras-navieras`, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(formDataRelacion),
      });

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Relación creada exitosamente",
          showConfirmButton: false,
          timer: 2000,
        });

        setShowNuevaRelacionModal(false);
        await cargarRelacionesEmpresa(empresaSeleccionada);
      } else {
        if (result.errors) {
          const errorsText = Object.values(result.errors).flat().join("\n");
          Swal.fire("Errores de validación", errorsText, "error");
        } else {
          Swal.fire("Error", result.message, "error");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", "Ocurrió un error al crear la relación", "error");
    } finally {
      setSaving(false);
    }
  };

  const eliminarRelacion = async (relacion) => {
    const result = await Swal.fire({
      title: "⚠️ Desactivar Relación",
      html: `<p>¿Desactivar esta relación?</p>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Sí, desactivar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(
          `${getApiUrl()}/almaceneras-navieras/${relacion.id}`,
          {
            method: "DELETE",
            headers: getHeaders(),
          },
        );

        if (response.ok) {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Relación desactivada",
            showConfirmButton: false,
            timer: 2000,
          });

          await cargarRelacionesEmpresa(empresaSeleccionada);
        }
      } catch (error) {
        console.error("Error:", error);
        Swal.fire("Error", "No se pudo desactivar la relación", "error");
      }
    }
  };

  const toggleEstadoRelacion = async (relacion) => {
    try {
      const response = await fetch(
        `${getApiUrl()}/almaceneras-navieras/${relacion.id}/toggle-estado`,
        {
          method: "PATCH",
          headers: getHeaders(),
        },
      );

      if (response.ok) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Estado actualizado",
          showConfirmButton: false,
          timer: 1500,
        });
        await cargarRelacionesEmpresa(empresaSeleccionada);
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", "No se pudo cambiar el estado", "error");
    }
  };

  const abrirModalRelacionesOperador = async (operador) => {
    setEmpresaSeleccionada(operador);
    setShowRelacionesOperadorModal(true);
    await cargarRelacionesOperador(operador.id);
  };

  const cargarRelacionesOperador = async (operadorId) => {
    setLoadingRelacionesOperador(true);
    try {
      const response = await fetch(
        `${getApiUrl()}/relaciones-operador/${operadorId}`,
        {
          headers: getHeaders(),
        },
      );

      if (response.ok) {
        const data = await response.json();
        setRelacionesOperador(data.data.relaciones || []);
        setEstadisticasOperador(data.data.estadisticas || {});
      } else {
        console.error("Error al cargar relaciones");
        setRelacionesOperador([]);
      }
    } catch (error) {
      console.error("Error:", error);
      setRelacionesOperador([]);
    } finally {
      setLoadingRelacionesOperador(false);
    }
  };

  const abrirModalNuevaRelacionOperador = async () => {
    setShowNuevaRelacionOperadorModal(true);
    await cargarEmpresasDisponiblesOperador(empresaSeleccionada.id);
  };

  const cargarEmpresasDisponiblesOperador = async (operadorId) => {
    setLoadingEmpresasOperador(true);
    try {
      const response = await fetch(
        `${getApiUrl()}/relaciones-operador/${operadorId}/empresas-disponibles`,
        {
          headers: getHeaders(),
        },
      );

      if (response.ok) {
        const data = await response.json();
        setEmpresasDisponibles(data.data);
      }
    } catch (error) {
      console.error("Error al cargar empresas disponibles:", error);
    } finally {
      setLoadingEmpresasOperador(false);
    }
  };

  const crearNuevaRelacionOperador = async () => {
    try {
      const endpoint =
        nuevaRelacion.tipo_relacion === "cliente"
          ? "/relaciones-operador/cliente"
          : "/relaciones-operador/transportista";

      const empresaKey =
        nuevaRelacion.tipo_relacion === "cliente"
          ? "empresaid_cliente"
          : "empresaid_transportista";

      const payload = {
        empresaid_operador: empresaSeleccionada.id,
        [empresaKey]: nuevaRelacion.empresa_id,
        fecha_inicio: nuevaRelacion.fecha_inicio,
        fecha_fin: nuevaRelacion.fecha_fin || null,
        estado: nuevaRelacion.estado,
      };

      const response = await fetch(`${getApiUrl()}${endpoint}`, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Relación creada exitosamente",
          showConfirmButton: false,
          timer: 2000,
        });

        setShowNuevaRelacionOperadorModal(false);
        setNuevaRelacion({
          tipo_relacion: "cliente",
          empresa_id: "",
          fecha_inicio: new Date().toISOString().split("T")[0],
          fecha_fin: "",
          estado: "ACTIVO",
        });
        await cargarRelacionesOperador(empresaSeleccionada.id);
      } else {
        const errorData = await response.json();
        Swal.fire(
          "Error",
          errorData.message || "Error al crear la relación",
          "error",
        );
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", "Error al crear la relación", "error");
    }
  };

  const toggleEstadoRelacionOperador = async (relacion) => {
    try {
      const endpoint =
        relacion.tipo_relacion === "cliente"
          ? `/relaciones-operador/cliente/${relacion.id}/toggle-estado`
          : `/relaciones-operador/transportista/${relacion.id}/toggle-estado`;

      const response = await fetch(`${getApiUrl()}${endpoint}`, {
        method: "PATCH",
        headers: getHeaders(),
      });

      if (response.ok) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Estado actualizado",
          showConfirmButton: false,
          timer: 1500,
        });
        await cargarRelacionesOperador(empresaSeleccionada.id);
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", "No se pudo cambiar el estado", "error");
    }
  };

  const desactivarRelacionOperador = async (relacion) => {
    const result = await Swal.fire({
      title: "¿Desactivar relación?",
      text: `Se desactivará la relación con ${relacion.empresa_relacionada?.nombre}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, desactivar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        const endpoint =
          relacion.tipo_relacion === "cliente"
            ? `/relaciones-operador/cliente/${relacion.id}`
            : `/relaciones-operador/transportista/${relacion.id}`;

        const response = await fetch(`${getApiUrl()}${endpoint}`, {
          method: "DELETE",
          headers: getHeaders(),
        });

        if (response.ok) {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Relación desactivada",
            showConfirmButton: false,
            timer: 2000,
          });
          await cargarRelacionesOperador(empresaSeleccionada.id);
        }
      } catch (error) {
        console.error("Error:", error);
        Swal.fire("Error", "No se pudo desactivar la relación", "error");
      }
    }
  };

  const getBadgeEstado = (estado, estadoVigencia) => {
    if (estado === "INACTIVO") return "bg-red-100 text-red-700";

    switch (estadoVigencia) {
      case "VIGENTE":
        return "bg-green-100 text-green-700";
      case "VENCIDO":
        return "bg-red-100 text-red-700";
      case "PENDIENTE":
        return "bg-orange-100 text-orange-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  return (
    <div className="space-y-2">
      {/* Header */}
      <Card>
        <CardHeader className="pb-2 pt-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Building2 className="h-4 w-4 text-blue-600" />
              <CardTitle className="text-sm">Gestión de Empresas</CardTitle>
              <Badge variant="outline" className="text-xs">
                {pagination.total} registros
              </Badge>
            </div>
            <div className="flex gap-1.5">
              <Button
                variant="outline"
                size="sm"
                onClick={loadEmpresas}
                disabled={loading}
                className="h-7 text-xs"
              >
                <RefreshCw
                  className={`h-3 w-3 ${loading ? "animate-spin" : ""}`}
                />
              </Button>
              <Button
                size="sm"
                onClick={openModal}
                className="bg-blue-600 hover:bg-blue-700 h-7 text-xs"
              >
                <Plus className="h-3 w-3 mr-1" />
                Nueva Empresa
              </Button>
            </div>
          </div>
        </CardHeader>
      </Card>

      {/* Filters */}
      <Card>
        <CardContent className="pt-2 pb-2">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-1.5">
            <div className="relative">
              <Search className="absolute left-2 top-2 h-3.5 w-3.5 text-gray-400" />
              <input
                type="text"
                placeholder="Buscar por nombre, RUC..."
                className="w-full pl-7 pr-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                value={filters.buscar}
                onChange={(e) =>
                  setFilters({ ...filters, buscar: e.target.value })
                }
              />
            </div>

            <select
              className="px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
              value={filters.tipo_empresa}
              onChange={(e) =>
                setFilters({ ...filters, tipo_empresa: e.target.value })
              }
            >
              <option value="">Todos los tipos</option>
              {tiposEmpresa.map((tipo) => (
                <option key={tipo.value} value={tipo.value}>
                  {tipo.label}
                </option>
              ))}
            </select>

            <select
              className="px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
              value={filters.activo}
              onChange={(e) =>
                setFilters({ ...filters, activo: e.target.value })
              }
            >
              <option value="">Todos los estados</option>
              <option value="true">Activos</option>
              <option value="false">Inactivos</option>
            </select>

            <Button
              variant="outline"
              size="sm"
              onClick={() =>
                setFilters({ buscar: "", activo: "", tipo_empresa: "" })
              }
              className="text-xs h-7"
            >
              Limpiar filtros
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Table */}
      <Card>
        <CardContent className="p-0">
          {loading ? (
            <div className="flex items-center justify-center py-8">
              <Loader2 className="h-5 w-5 animate-spin text-blue-600" />
              <span className="ml-2 text-xs text-gray-600">Cargando...</span>
            </div>
          ) : sortedEmpresas.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              <Building2 className="h-10 w-10 mx-auto mb-2 text-gray-300" />
              <p className="text-xs">No se encontraron empresas</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-xs">
                <thead className="bg-gray-50 border-b">
                  <tr>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-700">
                      <button
                        onClick={() => handleSort("nombre")}
                        className="flex items-center gap-1 hover:text-blue-600"
                      >
                        Empresa
                        <ArrowUpDown className="h-3 w-3" />
                      </button>
                    </th>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-700">
                      <button
                        onClick={() => handleSort("ruc")}
                        className="flex items-center gap-1 hover:text-blue-600"
                      >
                        RUC
                        <ArrowUpDown className="h-3 w-3" />
                      </button>
                    </th>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-700">
                      Ubicación
                    </th>
                    <th className="px-2 py-1.5 text-left font-medium text-gray-700">
                      <button
                        onClick={() => handleSort("tipo_empresa")}
                        className="flex items-center gap-1 hover:text-blue-600"
                      >
                        Tipo
                        <ArrowUpDown className="h-3 w-3" />
                      </button>
                    </th>
                    <th className="px-2 py-1.5 text-center font-medium text-gray-700">
                      Estado
                    </th>
                    <th className="px-2 py-1.5 text-center font-medium text-gray-700">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {sortedEmpresas.map((empresa) => (
                    <tr key={empresa.id} className="hover:bg-gray-50">
                      <td className="px-2 py-1.5">
                        <div className="font-medium text-gray-900">
                          {empresa.nombre}
                        </div>
                        {empresa.email && (
                          <div className="flex items-center gap-1 text-xs text-gray-500">
                            <Mail className="h-3 w-3" />
                            {empresa.email}
                          </div>
                        )}
                      </td>
                      <td className="px-2 py-1.5">
                        <div className="flex items-center gap-1">
                          <FileText className="h-3 w-3 text-gray-400" />
                          {empresa.ruc}
                        </div>
                      </td>
                      <td className="px-2 py-1.5">
                        {empresa.direccion && (
                          <div className="flex items-center gap-1 text-gray-600 mb-0.5">
                            <MapPin className="h-3 w-3 flex-shrink-0" />
                            <span className="line-clamp-2">
                              {empresa.direccion}
                            </span>
                          </div>
                        )}
                        {empresa.telefono && (
                          <div className="flex items-center gap-1 text-gray-600">
                            <Phone className="h-3 w-3" />
                            {empresa.telefono}
                          </div>
                        )}
                      </td>
                      <td className="px-2 py-1.5">
                        <Badge
                          className={`text-xs ${getTipoEmpresa(empresa.tipo_empresa).color
                            }`}
                        >
                          {getTipoEmpresa(empresa.tipo_empresa).label}
                        </Badge>
                      </td>
                      <td className="px-2 py-1.5 text-center">
                        <button
                          onClick={() => toggleActivo(empresa)}
                          className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-xs font-medium ${empresa.activo
                            ? "bg-green-100 text-green-700 hover:bg-green-200"
                            : "bg-red-100 text-red-700 hover:bg-red-200"
                            }`}
                        >
                          <Power className="h-3 w-3" />
                          {empresa.activo ? "Activo" : "Inactivo"}
                        </button>
                      </td>
                      <td className="px-2 py-1.5">
                        <div className="flex items-center justify-center gap-0.5">
                          <button
                            onClick={() => handleEdit(empresa)}
                            className="p-1 hover:bg-blue-50 rounded transition-colors"
                            title="Editar"
                          >
                            <Edit className="h-3.5 w-3.5 text-blue-600" />
                          </button>

                          {/* Botón de relaciones para ALMACENERA y NAVIERA */}
                          {(empresa.tipo_empresa === "ALMACENERA" ||
                            empresa.tipo_empresa === "NAVIERA") && (
                              <button
                                onClick={() => abrirModalRelaciones(empresa)}
                                className="p-1 hover:bg-purple-50 rounded transition-colors"
                                title={`Gestionar relaciones ${empresa.tipo_empresa === "ALMACENERA"
                                  ? "con navieras"
                                  : "con almaceneras"
                                  }`}
                              >
                                <Network className="h-3.5 w-3.5 text-purple-600" />
                              </button>
                            )}

                          {/* Botón de relaciones para OPERADOR_LOGISTICO */}
                          {empresa.tipo_empresa === "OPERADOR_LOGISTICO" && (
                            <button
                              onClick={() =>
                                abrirModalRelacionesOperador(empresa)
                              }
                              className="p-1 hover:bg-purple-50 rounded transition-colors"
                              title="Gestionar relaciones con clientes y transportistas"
                            >
                              <Network className="h-3.5 w-3.5 text-purple-600" />
                            </button>
                          )}

                          <button
                            onClick={() => abrirModalInvitarAdmin(empresa)}
                            className="p-1 hover:bg-green-50 rounded transition-colors"
                            title="Invitar Administrador"
                          >
                            <UserPlus className="h-3.5 w-3.5 text-green-600" />
                          </button>
                          {/* Botón Módulos — solo visible para Super Admin (empresa_id null en token) */}
                          <button
                            onClick={() => abrirModalModulos(empresa)}
                            className="p-1 hover:bg-indigo-50 rounded transition-colors"
                            title="Asignar módulos"
                          >
                            <Package className="h-3.5 w-3.5 text-indigo-600" />
                          </button>
                          <button
                            onClick={() => handleDelete(empresa)}
                            className="p-1 hover:bg-orange-50 rounded transition-colors"
                            title="Desactivar"
                          >
                            <Ban className="h-3.5 w-3.5 text-orange-600" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Pagination */}
          {pagination.total > 0 && (
            <div className="flex items-center justify-between px-2 py-1.5 border-t bg-gray-50">
              <div className="text-xs text-gray-600">
                Mostrando {pagination.from} - {pagination.to} de{" "}
                {pagination.total}
              </div>
              <div className="flex gap-1">
                <Button
                  variant="outline"
                  size="sm"
                  className="h-6 text-xs px-2"
                  disabled={pagination.current_page === 1}
                  onClick={() =>
                    setPagination({
                      ...pagination,
                      current_page: pagination.current_page - 1,
                    })
                  }
                >
                  Anterior
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  className="h-6 text-xs px-2"
                  disabled={pagination.current_page === pagination.last_page}
                  onClick={() =>
                    setPagination({
                      ...pagination,
                      current_page: pagination.current_page + 1,
                    })
                  }
                >
                  Siguiente
                </Button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>

      {/* Modal Empresas (existente) */}
      {showModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3 backdrop-blur-sm">
          <Card className="w-full max-w-2xl max-h-[95vh] overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-200">
            <CardHeader className="pb-2 pt-3 border-b bg-gradient-to-r from-blue-50 to-purple-50">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="p-1.5 bg-blue-600 rounded-lg">
                    <Building2 className="h-4 w-4 text-white" />
                  </div>
                  <CardTitle className="text-sm font-semibold">
                    {editingEmpresa ? "Editar Empresa" : "Nueva Empresa"}
                  </CardTitle>
                </div>
                <button
                  onClick={closeModal}
                  className="p-1 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
            </CardHeader>
            <CardContent className="pt-3 pb-3 max-h-[calc(95vh-120px)] overflow-y-auto">
              <form onSubmit={handleSubmit} className="space-y-3">
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <label htmlFor="emp_nombre" className="block text-xs font-medium text-gray-700 mb-1">
                      Nombre <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="emp_nombre"
                      type="text"
                      required
                      className="w-full px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={formData.nombre}
                      onChange={(e) =>
                        setFormData({ ...formData, nombre: e.target.value })
                      }
                    />
                  </div>

                  <div>
                    <label htmlFor="emp_ruc" className="block text-xs font-medium text-gray-700 mb-1">
                      RUC <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="emp_ruc"
                      type="text"
                      required
                      className="w-full px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={formData.ruc}
                      onChange={(e) =>
                        setFormData({ ...formData, ruc: e.target.value })
                      }
                    />
                  </div>

                  <div>
                    <label htmlFor="emp_email" className="block text-xs font-medium text-gray-700 mb-1">
                      Email
                    </label>
                    <input
                      id="emp_email"
                      type="email"
                      className="w-full px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                    />
                  </div>

                  <div>
                    <label htmlFor="emp_telefono" className="block text-xs font-medium text-gray-700 mb-1">
                      Teléfono
                    </label>
                    <input
                      id="emp_telefono"
                      type="text"
                      className="w-full px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={formData.telefono}
                      onChange={(e) =>
                        setFormData({ ...formData, telefono: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-span-2">
                    <label htmlFor="emp_direccion" className="block text-xs font-medium text-gray-700 mb-1">
                      Dirección
                    </label>
                    <textarea
                      id="emp_direccion"
                      rows="2"
                      className="w-full px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                      value={formData.direccion}
                      onChange={(e) =>
                        setFormData({ ...formData, direccion: e.target.value })
                      }
                    />
                  </div>

                  <div>
                    <label htmlFor="emp_tipo_empresa" className="block text-xs font-medium text-gray-700 mb-1">
                      Tipo de Empresa <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="emp_tipo_empresa"
                      required
                      className="w-full px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={formData.tipo_empresa}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          tipo_empresa: e.target.value,
                        })
                      }
                    >
                      {tiposEmpresa.map((tipo) => (
                        <option key={tipo.value} value={tipo.value}>
                          {tipo.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  {!editingEmpresa && (
                    <div className="col-span-2">
                      <label className="block text-xs font-medium text-gray-700 mb-1">
                        Plantilla de Roles{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      {/* <select
                        required
                        className="w-full px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={formData.plantilla_empresa_id}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            plantilla_empresa_id: e.target.value,
                          })
                        }
                        disabled={loadingPlantillas}
                      >
                        <option value="">
                          {loadingPlantillas
                            ? "Cargando plantillas..."
                            : "Seleccionar plantilla..."}
                        </option>
                        {plantillasDisponibles.map((plantilla) => (
                          <option key={plantilla.id} value={plantilla.id}>
                            {plantilla.nombre} ({plantilla.roles_count || 0}{" "}
                            roles)
                          </option>
                        ))}
                      </select> */}
                      <p className="text-xs text-gray-500 mt-1">
                        💡 Los roles y permisos se copiarán de esta empresa
                      </p>
                    </div>
                  )}
                   {/* LOGO */}
  <div className="col-span-2">
      <label className="block text-xs font-medium text-gray-700 mb-1">
          Logo de la empresa
          <span className="ml-1 text-gray-400 font-normal">
              (SVG · PNG · WEBP · JPG — máx. 2 MB)
          </span>
      </label>
      <div className="flex items-center gap-3">
          <div className="flex-shrink-0 w-14 h-14 rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 flex items-center justify-center overflow-hidden">
              {logoPreview ? (
                  <img
                      src={logoPreview}
                      alt="Logo"
                      className="w-full h-full object-contain p-1"
                  />
              ) : (
                  <Building2 className="h-6 w-6 text-gray-300" />
              )}
          </div>
          <div className="flex-1 space-y-1">
              <label className="cursor-pointer inline-flex items-center gap-1.5 px-3 py-1.5 text-xs bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
                  <input
                      type="file"
                      accept=".svg,.png,.webp,.jpg,.jpeg"
                      className="hidden"
                      onChange={handleLogoChange}
                  />
                  Seleccionar archivo
              </label>
              {logoFile && (
                  <p className="text-xs text-gray-500 truncate max-w-xs">
                      {logoFile.name}
                  </p>
              )}
              {logoPreview && (
                  <button
                      type="button"
                      onClick={() => { setLogoFile(null); setLogoPreview(null); }}
                      className="text-xs text-red-500 hover:text-red-700 flex items-center gap-1"
                  >
                      <X className="h-3 w-3" /> Quitar logo
                  </button>
              )}
              <p className="text-xs text-gray-400">
                  Recomendado: SVG o PNG con fondo transparente
              </p>
          </div>
      </div>
  </div>
                  <div className="flex items-center gap-2 pt-4">
                    <Checkbox
                      id="activo"
                      checked={formData.activo}
                      onCheckedChange={(checked) =>
                        setFormData({ ...formData, activo: checked })
                      }
                    />
                    <label
                      htmlFor="activo"
                      className="text-xs font-medium cursor-pointer"
                    >
                      Empresa Activa
                    </label>
                  </div>
                </div>

                <div className="flex justify-end gap-1.5 pt-2 border-t mt-3">
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={closeModal}
                    disabled={saving}
                    className="h-7 text-xs"
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    size="sm"
                    disabled={saving}
                    className="bg-blue-600 hover:bg-blue-700 h-7 text-xs"
                  >
                    {saving ? (
                      <>
                        <Loader2 className="h-3 w-3 mr-1 animate-spin" />
                        Guardando...
                      </>
                    ) : (
                      <>
                        <Save className="h-3 w-3 mr-1" />
                        {editingEmpresa ? "Actualizar" : "Crear"}
                      </>
                    )}
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      )}

      {/* MODAL DE RELACIONES ALMACENERAS-NAVIERAS (existente) */}
      {showRelacionesModal && empresaSeleccionada && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3 backdrop-blur-sm">
          <Card className="w-full max-w-3xl max-h-[95vh] overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-200">
            <CardHeader className="pb-2 pt-3 border-b bg-gradient-to-r from-purple-50 to-blue-50">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="p-1.5 bg-purple-600 rounded-lg">
                    <Network className="h-4 w-4 text-white" />
                  </div>
                  <div>
                    <CardTitle className="text-sm font-semibold">
                      Relaciones de {empresaSeleccionada.nombre}
                    </CardTitle>
                    <p className="text-xs text-gray-600">
                      {empresaSeleccionada.tipo_empresa === "ALMACENERA"
                        ? "Navieras relacionadas"
                        : "Almaceneras relacionadas"}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  <Button
                    size="sm"
                    onClick={abrirModalNuevaRelacion}
                    className="bg-blue-600 hover:bg-blue-700 h-6 text-xs px-2"
                  >
                    <Plus className="h-3 w-3 mr-1" />
                    Nueva
                  </Button>
                  <button
                    onClick={() => setShowRelacionesModal(false)}
                    className="p-1 hover:bg-gray-200 rounded-lg transition-colors"
                  >
                    <X className="h-4 w-4" />
                  </button>
                </div>
              </div>
            </CardHeader>

            <CardContent className="p-3 max-h-[calc(95vh-120px)] overflow-y-auto">
              {loadingRelaciones ? (
                <div className="flex items-center justify-center py-8">
                  <Loader2 className="h-5 w-5 animate-spin text-purple-600" />
                  <span className="ml-2 text-xs text-gray-600">
                    Cargando relaciones...
                  </span>
                </div>
              ) : relacionesEmpresa.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  <Network className="h-10 w-10 mx-auto mb-2 text-gray-300" />
                  <p className="text-xs mb-2">No hay relaciones configuradas</p>
                  <Button
                    size="sm"
                    onClick={abrirModalNuevaRelacion}
                    className="bg-blue-600 hover:bg-blue-700 h-7 text-xs"
                  >
                    <Plus className="h-3 w-3 mr-1" />
                    Crear primera relación
                  </Button>
                </div>
              ) : (
                <div className="space-y-1">
                  {/* Header sticky con alineación exacta */}
                  <div className="sticky top-0 z-10 bg-white pb-1">
                    <div className="bg-gray-50 rounded-lg border p-2 shadow-sm">
                      <div className="grid grid-cols-12 gap-2 items-center text-xs font-medium text-gray-600">
                        <div className="col-span-4">Empresa</div>
                        <div className="col-span-2">RUC</div>
                        <div className="col-span-2 text-center">Estado</div>
                        <div className="col-span-3 text-center">Vigencia</div>
                        <div className="col-span-1 text-center">Acciones</div>
                      </div>
                    </div>
                  </div>

                  {/* Lista de relaciones con scroll */}
                  <div className="space-y-1 max-h-96 overflow-y-auto">
                    {relacionesEmpresa.map((relacion) => (
                      <div
                        key={relacion.id}
                        className="border border-gray-200 rounded-lg p-2 hover:bg-gray-50 transition-colors"
                      >
                        <div className="grid grid-cols-12 gap-2 items-center">
                          {/* Icono + Nombre (col-span-4) */}
                          <div className="col-span-4 flex items-center gap-2 min-w-0">
                            <Building2 className="h-4 w-4 text-gray-400 flex-shrink-0" />
                            <div className="min-w-0 flex-1">
                              <div className="text-sm font-medium text-gray-900 break-words leading-tight">
                                {empresaSeleccionada.tipo_empresa ===
                                  "ALMACENERA"
                                  ? relacion.empresa_naviera?.nombre
                                  : relacion.empresa_almacenera?.nombre}
                              </div>
                            </div>
                          </div>

                          {/* RUC (col-span-2) */}
                          <div className="col-span-2 min-w-0">
                            <div className="text-xs text-gray-500 truncate">
                              {empresaSeleccionada.tipo_empresa === "ALMACENERA"
                                ? relacion.empresa_naviera?.ruc
                                : relacion.empresa_almacenera?.ruc}
                            </div>
                          </div>

                          {/* Badge Estado (col-span-2) */}
                          <div className="col-span-2 flex justify-center">
                            <Badge
                              className={`text-xs ${getBadgeEstado(
                                relacion.estado,
                                relacion.estado_vigencia,
                              )}`}
                            >
                              {relacion.estado_vigencia || relacion.estado}
                            </Badge>
                          </div>

                          {/* Fechas (col-span-3) */}
                          <div className="col-span-3 text-xs text-gray-600">
                            <div className="flex items-center gap-1 justify-center">
                              <Calendar className="h-3 w-3 flex-shrink-0" />
                              <span className="truncate">
                                {new Date(
                                  relacion.fecha_inicio,
                                ).toLocaleDateString()}
                              </span>
                              {relacion.fecha_fin && (
                                <>
                                  <span className="text-gray-400">→</span>
                                  <span className="truncate">
                                    {new Date(
                                      relacion.fecha_fin,
                                    ).toLocaleDateString()}
                                  </span>
                                </>
                              )}
                            </div>
                          </div>

                          {/* Acciones (col-span-1) */}
                          <div className="col-span-1 flex items-center justify-end gap-1">
                            <button
                              onClick={() => toggleEstadoRelacion(relacion)}
                              className={`p-1 rounded transition-colors ${relacion.estado === "ACTIVO"
                                ? "text-green-600 hover:bg-green-50"
                                : "text-gray-400 hover:bg-gray-50"
                                }`}
                              title={
                                relacion.estado === "ACTIVO"
                                  ? "Desactivar"
                                  : "Activar"
                              }
                            >
                              {relacion.estado === "ACTIVO" ? (
                                <ToggleRight className="h-3.5 w-3.5" />
                              ) : (
                                <ToggleLeft className="h-3.5 w-3.5" />
                              )}
                            </button>
                            <button
                              onClick={() => eliminarRelacion(relacion)}
                              className="p-1 text-red-600 hover:bg-red-50 rounded transition-colors"
                              title="Desactivar relación"
                            >
                              <Ban className="h-3.5 w-3.5" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      )}

      {/* MODAL NUEVA RELACIÓN ALMACENERA-NAVIERA (existente) */}
      {showNuevaRelacionModal && empresaSeleccionada && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] p-3 backdrop-blur-sm">
          <Card className="w-full max-w-md overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-200">
            <CardHeader className="pb-2 pt-3 border-b bg-gradient-to-r from-blue-50 to-green-50">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="p-1.5 bg-blue-600 rounded-lg">
                    <Plus className="h-4 w-4 text-white" />
                  </div>
                  <CardTitle className="text-sm font-semibold">
                    Nueva Relación
                  </CardTitle>
                </div>
                <button
                  onClick={() => setShowNuevaRelacionModal(false)}
                  className="p-1 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
            </CardHeader>

            <CardContent className="pt-3 pb-3">
              <form onSubmit={crearNuevaRelacion} className="space-y-3">
                {/* Empresa fija */}
                <div>
                  <label htmlFor="emp_fija" className="block text-xs font-medium text-gray-700 mb-1">
                    {empresaSeleccionada.tipo_empresa}
                  </label>
                  <input
                    id="emp_fija"
                    type="text"
                    value={`${empresaSeleccionada.nombre} - ${empresaSeleccionada.ruc}`}
                    className="w-full px-2 py-1.5 text-xs border rounded-md bg-gray-50"
                    disabled
                  />
                </div>

                {/* Empresa a relacionar */}
                <div>
                  <label htmlFor="emp_relacionar" className="block text-xs font-medium text-gray-700 mb-1">
                    {empresaSeleccionada.tipo_empresa === "ALMACENERA"
                      ? "Naviera"
                      : "Almacenera"}
                    <span className="text-red-500 ml-1">*</span>
                  </label>
                  <select
                    id="emp_relacionar"
                    value={
                      empresaSeleccionada.tipo_empresa === "ALMACENERA"
                        ? formDataRelacion.empresaid_naviera
                        : formDataRelacion.empresaid_almacenera
                    }
                    onChange={(e) => {
                      if (empresaSeleccionada.tipo_empresa === "ALMACENERA") {
                        setFormDataRelacion((prev) => ({
                          ...prev,
                          empresaid_naviera: e.target.value,
                        }));
                      } else {
                        setFormDataRelacion((prev) => ({
                          ...prev,
                          empresaid_almacenera: e.target.value,
                        }));
                      }
                    }}
                    className="w-full px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                    disabled={loadingEmpresas}
                  >
                    <option value="">
                      {loadingEmpresas
                        ? "Cargando empresas..."
                        : `Seleccionar ${empresaSeleccionada.tipo_empresa === "ALMACENERA"
                          ? "naviera"
                          : "almacenera"
                        }...`}
                    </option>
                    {!loadingEmpresas &&
                      getEmpresasDisponiblesParaRelacion().map((empresa) => (
                        <option
                          key={empresa.id}
                          value={empresa.id}
                          disabled={empresa.tieneRelacion}
                          style={
                            empresa.tieneRelacion
                              ? {
                                color: "#9CA3AF",
                                backgroundColor: "#F3F4F6",
                              }
                              : {}
                          }
                        >
                          {empresa.nombre} - {empresa.ruc}
                          {empresa.tieneRelacion ? " (Ya relacionada)" : ""}
                        </option>
                      ))}
                  </select>

                  {loadingEmpresas && (
                    <div className="flex items-center gap-1 mt-1 text-xs text-gray-500">
                      <Loader2 className="h-3 w-3 animate-spin" />
                      Obteniendo empresas disponibles...
                    </div>
                  )}
                </div>

                {/* Fechas */}
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <label htmlFor="fecha_inicio_rel" className="block text-xs font-medium text-gray-700 mb-1">
                      Fecha Inicio <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="fecha_inicio_rel"
                      type="date"
                      value={formDataRelacion.fecha_inicio}
                      onChange={(e) =>
                        setFormDataRelacion((prev) => ({
                          ...prev,
                          fecha_inicio: e.target.value,
                        }))
                      }
                      className="w-full px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="fecha_fin_rel" className="block text-xs font-medium text-gray-700 mb-1">
                      Fecha Fin{" "}
                      <span className="text-xs text-gray-500">(opcional)</span>
                    </label>
                    <input
                      id="fecha_fin_rel"
                      type="date"
                      value={formDataRelacion.fecha_fin}
                      onChange={(e) =>
                        setFormDataRelacion((prev) => ({
                          ...prev,
                          fecha_fin: e.target.value,
                        }))
                      }
                      min={formDataRelacion.fecha_inicio}
                      className="w-full px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>

                {/* Estado */}
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                  <div className="flex items-center gap-2">
                    <div
                      className={`p-1 rounded ${formDataRelacion.estado === "ACTIVO"
                        ? "bg-green-100"
                        : "bg-gray-100"
                        }`}
                    >
                      {formDataRelacion.estado === "ACTIVO" ? (
                        <ToggleRight className="h-3 w-3 text-green-600" />
                      ) : (
                        <ToggleLeft className="h-3 w-3 text-gray-400" />
                      )}
                    </div>
                    <span className="text-xs font-medium">
                      {formDataRelacion.estado === "ACTIVO"
                        ? "Activa"
                        : "Inactiva"}
                    </span>
                  </div>
                  <button
                    type="button"
                    onClick={() =>
                      setFormDataRelacion((prev) => ({
                        ...prev,
                        estado:
                          prev.estado === "ACTIVO" ? "INACTIVO" : "ACTIVO",
                      }))
                    }
                    className={`relative inline-flex h-4 w-7 items-center rounded-full transition-colors ${formDataRelacion.estado === "ACTIVO"
                      ? "bg-blue-600"
                      : "bg-gray-300"
                      }`}
                  >
                    <span
                      className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform ${formDataRelacion.estado === "ACTIVO"
                        ? "translate-x-4"
                        : "translate-x-0.5"
                        }`}
                    />
                  </button>
                </div>

                {/* Botones */}
                <div className="flex justify-end gap-1.5 pt-2 border-t">
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => setShowNuevaRelacionModal(false)}
                    disabled={saving}
                    className="h-6 text-xs"
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    size="sm"
                    disabled={saving}
                    className="bg-blue-600 hover:bg-blue-700 h-6 text-xs"
                  >
                    {saving ? (
                      <>
                        <Loader2 className="h-3 w-3 mr-1 animate-spin" />
                        Creando...
                      </>
                    ) : (
                      <>
                        <Save className="h-3 w-3 mr-1" />
                        Crear
                      </>
                    )}
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      )}

      {/* NUEVO: MODAL DE RELACIONES DEL OPERADOR - APLICANDO MISMO ESTILO */}
      {showRelacionesOperadorModal && empresaSeleccionada && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3 backdrop-blur-sm">
          <Card className="w-full max-w-4xl max-h-[95vh] overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-200">
            <CardHeader className="pb-2 pt-3 border-b bg-gradient-to-r from-purple-50 to-blue-50">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="p-1.5 bg-purple-600 rounded-lg">
                    <Network className="h-4 w-4 text-white" />
                  </div>
                  <div>
                    <CardTitle className="text-sm font-semibold">
                      Relaciones de {empresaSeleccionada.nombre}
                    </CardTitle>
                    <p className="text-xs text-gray-600">
                      Gestionar clientes y transportistas
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  {/* Estadísticas rápidas */}
                  <div className="flex items-center gap-2 mr-3 text-xs">
                    <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded">
                      {estadisticasOperador.total_clientes || 0} Clientes
                    </span>
                    <span className="bg-green-100 text-green-700 px-2 py-1 rounded">
                      {estadisticasOperador.total_transportistas || 0}{" "}
                      Transportistas
                    </span>
                  </div>
                  <Button
                    size="sm"
                    onClick={abrirModalNuevaRelacionOperador}
                    className="bg-blue-600 hover:bg-blue-700 h-6 text-xs px-2"
                  >
                    <Plus className="h-3 w-3 mr-1" />
                    Nueva
                  </Button>
                  <button
                    onClick={() => setShowRelacionesOperadorModal(false)}
                    className="p-1 hover:bg-gray-200 rounded-lg transition-colors"
                  >
                    <X className="h-4 w-4" />
                  </button>
                </div>
              </div>
            </CardHeader>

            <CardContent className="p-3 max-h-[calc(95vh-120px)] overflow-y-auto">
              {loadingRelacionesOperador ? (
                <div className="flex items-center justify-center py-8">
                  <Loader2 className="h-5 w-5 animate-spin text-purple-600" />
                  <span className="ml-2 text-xs text-gray-600">
                    Cargando relaciones...
                  </span>
                </div>
              ) : relacionesOperador.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  <Network className="h-10 w-10 mx-auto mb-2 text-gray-300" />
                  <p className="text-xs mb-2">No hay relaciones configuradas</p>
                  <Button
                    size="sm"
                    onClick={abrirModalNuevaRelacionOperador}
                    className="bg-blue-600 hover:bg-blue-700 h-7 text-xs"
                  >
                    <Plus className="h-3 w-3 mr-1" />
                    Crear primera relación
                  </Button>
                </div>
              ) : (
                <div className="space-y-1">
                  {/* APLICANDO MISMO ESTILO: Header sticky con alineación exacta */}
                  <div className="sticky top-0 z-10 bg-white pb-1">
                    <div className="bg-gray-50 rounded-lg border p-2 shadow-sm">
                      <div className="grid grid-cols-12 gap-2 items-center text-xs font-medium text-gray-600">
                        <div className="col-span-4">Empresa</div>
                        <div className="col-span-2">RUC</div>
                        <div className="col-span-1 text-center">Tipo</div>
                        <div className="col-span-2 text-center">Estado</div>
                        <div className="col-span-2 text-center">Vigencia</div>
                        <div className="col-span-1 text-center">Acciones</div>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-1 max-h-96 overflow-y-auto">
                    {relacionesOperador.map((relacion) => (
                      <div
                        key={`${relacion.tipo_relacion}-${relacion.id}`}
                        className="border border-gray-200 rounded-lg p-2 hover:bg-gray-50 transition-colors"
                      >
                        <div className="grid grid-cols-12 gap-2 items-center">
                          {/* Icono + Nombre (col-span-4) */}
                          <div className="col-span-4 flex items-center gap-2 min-w-0">
                            {relacion.tipo_relacion === "cliente" ? (
                              <Building2 className="h-4 w-4 text-blue-400 flex-shrink-0" />
                            ) : (
                              <Truck className="h-4 w-4 text-green-400 flex-shrink-0" />
                            )}
                            <div className="min-w-0 flex-1">
                              <div className="text-sm font-medium text-gray-900 break-words leading-tight">
                                {relacion.empresa_relacionada?.nombre}
                              </div>
                            </div>
                          </div>

                          {/* RUC (col-span-2) */}
                          <div className="col-span-2 min-w-0">
                            <div className="text-xs text-gray-500 truncate">
                              {relacion.empresa_relacionada?.ruc}
                            </div>
                          </div>

                          {/* Tipo (col-span-2) */}
                          <div className="col-span-1 flex justify-center">
                            <Badge
                              className={`text-xs ${relacion.tipo_relacion === "cliente"
                                ? "bg-blue-100 text-blue-700"
                                : "bg-green-100 text-green-700"
                                }`}
                            >
                              {relacion.tipo_relacion.toUpperCase()}
                            </Badge>
                          </div>

                          {/* Estado (col-span-2) */}
                          <div className="col-span-2 flex justify-center">
                            <Badge
                              className={`text-xs ${getBadgeEstado(
                                relacion.estado,
                                relacion.estado_vigencia,
                              )}`}
                            >
                              {relacion.estado_vigencia}
                            </Badge>
                          </div>

                          {/* Fechas (col-span-1) */}
                          <div className="col-span-2 text-xs text-gray-600">
                            <div className="flex items-center gap-1 justify-center">
                              <Calendar className="h-3 w-3 flex-shrink-0" />
                              <span className="truncate">
                                {new Date(
                                  relacion.fecha_inicio,
                                ).toLocaleDateString()}
                              </span>
                            </div>
                            {relacion.fecha_fin && (
                              <div className="flex items-center gap-1 justify-center">
                                <span className="text-gray-400 text-center">
                                  →
                                </span>
                                <span className="truncate">
                                  {new Date(
                                    relacion.fecha_fin,
                                  ).toLocaleDateString()}
                                </span>
                              </div>
                            )}
                          </div>

                          {/* Acciones (col-span-1) */}
                          <div className="col-span-1 flex items-center justify-end gap-1">
                            <button
                              onClick={() =>
                                toggleEstadoRelacionOperador(relacion)
                              }
                              className={`p-1 rounded transition-colors ${relacion.estado === "ACTIVO"
                                ? "text-green-600 hover:bg-green-50"
                                : "text-gray-400 hover:bg-gray-50"
                                }`}
                              title={
                                relacion.estado === "ACTIVO"
                                  ? "Desactivar"
                                  : "Activar"
                              }
                            >
                              {relacion.estado === "ACTIVO" ? (
                                <ToggleRight className="h-3.5 w-3.5" />
                              ) : (
                                <ToggleLeft className="h-3.5 w-3.5" />
                              )}
                            </button>
                            <button
                              onClick={() =>
                                desactivarRelacionOperador(relacion)
                              }
                              className="p-1 text-red-600 hover:bg-red-50 rounded transition-colors"
                              title="Desactivar relación"
                            >
                              <Ban className="h-3.5 w-3.5" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      )}

      {/* NUEVO: MODAL DE NUEVA RELACIÓN OPERADOR - APLICANDO MISMO ESTILO */}
      {showNuevaRelacionOperadorModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] p-3 backdrop-blur-sm">
          <Card className="w-full max-w-md overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-200">
            <CardHeader className="pb-2 pt-3 border-b bg-gradient-to-r from-blue-50 to-green-50">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="p-1.5 bg-blue-600 rounded-lg">
                    <Plus className="h-4 w-4 text-white" />
                  </div>
                  <CardTitle className="text-sm font-semibold">
                    Nueva Relación
                  </CardTitle>
                </div>
                <button
                  onClick={() => setShowNuevaRelacionOperadorModal(false)}
                  className="p-1 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
            </CardHeader>

            <CardContent className="pt-3 pb-3">
              <div className="space-y-3">
                {/* Empresa fija */}
                <div>
                  <label htmlFor="op_fijo" className="block text-xs font-medium text-gray-700 mb-1">
                    Operador Logístico
                  </label>
                  <input
                    id="op_fijo"
                    type="text"
                    value={`${empresaSeleccionada.nombre} - ${empresaSeleccionada.ruc}`}
                    className="w-full px-2 py-1.5 text-xs border rounded-md bg-gray-50"
                    disabled
                  />
                </div>

                {/* Tipo de relación */}
                <div>
                  <label htmlFor="op_tipo_relacion" className="block text-xs font-medium text-gray-700 mb-1">
                    Tipo de relación
                  </label>
                  <select
                    id="op_tipo_relacion"
                    value={nuevaRelacion.tipo_relacion}
                    onChange={(e) =>
                      setNuevaRelacion((prev) => ({
                        ...prev,
                        tipo_relacion: e.target.value,
                        empresa_id: "",
                      }))
                    }
                    className="w-full text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="cliente">Cliente</option>
                    <option value="transportista">Transportista</option>
                  </select>
                </div>

                {/* Empresa a relacionar */}
                <div>
                  <label htmlFor="op_empresa_relacionar" className="block text-xs font-medium text-gray-700 mb-1">
                    {nuevaRelacion.tipo_relacion === "cliente"
                      ? "Cliente"
                      : "Transportista"}
                    <span className="text-red-500 ml-1">*</span>
                  </label>
                  <select
                    id="op_empresa_relacionar"
                    value={nuevaRelacion.empresa_id}
                    onChange={(e) =>
                      setNuevaRelacion((prev) => ({
                        ...prev,
                        empresa_id: e.target.value,
                      }))
                    }
                    className="w-full text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    required
                    disabled={loadingEmpresasOperador}
                  >
                    <option value="">
                      {loadingEmpresasOperador
                        ? "Cargando empresas..."
                        : `Seleccionar ${nuevaRelacion.tipo_relacion}...`}
                    </option>
                    {!loadingEmpresasOperador &&
                      (nuevaRelacion.tipo_relacion === "cliente"
                        ? empresasDisponibles.clientes_disponibles
                        : empresasDisponibles.transportistas_disponibles
                      ).map((empresa) => (
                        <option key={empresa.id} value={empresa.id}>
                          {empresa.nombre} - {empresa.ruc}
                        </option>
                      ))}
                  </select>

                  {loadingEmpresasOperador && (
                    <div className="flex items-center gap-1 mt-1 text-xs text-gray-500">
                      <Loader2 className="h-3 w-3 animate-spin" />
                      Obteniendo empresas disponibles...
                    </div>
                  )}
                </div>

                {/* Fechas */}
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <label htmlFor="op_fecha_inicio" className="block text-xs font-medium text-gray-700 mb-1">
                      Fecha Inicio <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="op_fecha_inicio"
                      type="date"
                      value={nuevaRelacion.fecha_inicio}
                      onChange={(e) =>
                        setNuevaRelacion((prev) => ({
                          ...prev,
                          fecha_inicio: e.target.value,
                        }))
                      }
                      className="w-full text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label htmlFor="op_fecha_fin" className="block text-xs font-medium text-gray-700 mb-1">
                      Fecha Fin{" "}
                      <span className="text-xs text-gray-500">(opcional)</span>
                    </label>
                    <input
                      id="op_fecha_fin"
                      type="date"
                      value={nuevaRelacion.fecha_fin}
                      onChange={(e) =>
                        setNuevaRelacion((prev) => ({
                          ...prev,
                          fecha_fin: e.target.value,
                        }))
                      }
                      min={nuevaRelacion.fecha_inicio}
                      className="w-full text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>

                {/* Estado */}
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                  <div className="flex items-center gap-2">
                    <div
                      className={`p-1 rounded ${nuevaRelacion.estado === "ACTIVO"
                        ? "bg-green-100"
                        : "bg-gray-100"
                        }`}
                    >
                      {nuevaRelacion.estado === "ACTIVO" ? (
                        <ToggleRight className="h-3 w-3 text-green-600" />
                      ) : (
                        <ToggleLeft className="h-3 w-3 text-gray-400" />
                      )}
                    </div>
                    <span className="text-xs font-medium">
                      {nuevaRelacion.estado === "ACTIVO"
                        ? "Activa"
                        : "Inactiva"}
                    </span>
                  </div>
                  <button
                    type="button"
                    onClick={() =>
                      setNuevaRelacion((prev) => ({
                        ...prev,
                        estado:
                          prev.estado === "ACTIVO" ? "INACTIVO" : "ACTIVO",
                      }))
                    }
                    className={`relative inline-flex h-4 w-7 items-center rounded-full transition-colors ${nuevaRelacion.estado === "ACTIVO"
                      ? "bg-blue-600"
                      : "bg-gray-300"
                      }`}
                  >
                    <span
                      className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform ${nuevaRelacion.estado === "ACTIVO"
                        ? "translate-x-4"
                        : "translate-x-0.5"
                        }`}
                    />
                  </button>
                </div>

                {/* Botones */}
                <div className="flex justify-end gap-1.5 pt-2 border-t">
                  <Button
                    onClick={() => setShowNuevaRelacionOperadorModal(false)}
                    variant="outline"
                    size="sm"
                    className="h-6 text-xs"
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={crearNuevaRelacionOperador}
                    size="sm"
                    className="bg-blue-600 hover:bg-blue-700 h-6 text-xs"
                    disabled={!nuevaRelacion.empresa_id}
                  >
                    <Save className="h-3 w-3 mr-1" />
                    Crear
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {showInvitarAdminModal && empresaParaInvitar && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] p-3 backdrop-blur-sm">
          <Card className="w-full max-w-md overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-200">
            <CardHeader className="pb-2 pt-3 border-b bg-gradient-to-r from-green-50 to-blue-50">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="p-1.5 bg-green-600 rounded-lg">
                    <UserPlus className="h-4 w-4 text-white" />
                  </div>
                  <div>
                    <CardTitle className="text-sm font-semibold">
                      Invitar Administrador
                    </CardTitle>
                    <p className="text-xs text-gray-600">
                      {empresaParaInvitar.nombre}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => setShowInvitarAdminModal(false)}
                  className="p-1 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
            </CardHeader>

            <CardContent className="pt-3 pb-3">
              <form onSubmit={enviarInvitacionAdmin} className="space-y-3">
                <div>
                  <label htmlFor="inv_nombre" className="block text-xs font-medium text-gray-700 mb-1">
                    Nombre Completo <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="inv_nombre"
                    type="text"
                    required
                    className="w-full px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                    value={formInvitacion.admin_nombre}
                    onChange={(e) =>
                      setFormInvitacion({
                        ...formInvitacion,
                        admin_nombre: e.target.value,
                      })
                    }
                    placeholder="Juan Pérez"
                  />
                </div>

                <div>
                  <label htmlFor="inv_email" className="block text-xs font-medium text-gray-700 mb-1">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="inv_email"
                    type="email"
                    required
                    className="w-full px-2 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                    value={formInvitacion.admin_email}
                    onChange={(e) =>
                      setFormInvitacion({
                        ...formInvitacion,
                        admin_email: e.target.value,
                      })
                    }
                    placeholder="admin@empresa.com"
                  />
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-2">
                  <p className="text-xs text-blue-800">
                    💡 Se enviará un email de invitación con un enlace para que
                    el administrador configure su cuenta.
                  </p>
                </div>

                <div className="flex justify-end gap-1.5 pt-2 border-t">
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => setShowInvitarAdminModal(false)}
                    disabled={saving}
                    className="h-7 text-xs"
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    size="sm"
                    disabled={saving}
                    className="bg-green-600 hover:bg-green-700 h-7 text-xs"
                  >
                    {saving ? (
                      <>
                        <Loader2 className="h-3 w-3 mr-1 animate-spin" />
                        Enviando...
                      </>
                    ) : (
                      <>
                        <Mail className="h-3 w-3 mr-1" />
                        Enviar Invitación
                      </>
                    )}
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      )}
      {/* Modal Módulos de Empresa */}
      {showModulosModal && empresaParaModulos && (
        <ModulosEmpresa
          empresa={empresaParaModulos}
          onClose={() => {
            setShowModulosModal(false);
            setEmpresaParaModulos(null);
          }}
          onModulosActualizados={loadEmpresas}
        />
      )}
    </div>
  );
};

export default Empresas;
